import { render } from "./MbrandCreate.vue?vue&type=template&id=caf01942&scoped=true"
import script from "./MbrandCreate.vue?vue&type=script&lang=js"
export * from "./MbrandCreate.vue?vue&type=script&lang=js"

import "./MbrandCreate.vue?vue&type=style&index=0&id=caf01942&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf01942"]])

export default __exports__